import CustomSingleSelect from './CustomSingleSelect';
import './CustomSingleSelect.scss';

export default CustomSingleSelect;
